module.exports = __webpack_public_path__ + "static/media/sylt-min.a80cab80.png";